import React, { useEffect, useState } from "react";
import { SimpleSingleSelect } from "../../../components/FormComponents/SimpleSingleSelect";
import "./CoverageResultsStyle/CoverageResultsStyle.scss";
import { PlanDetailsCard } from "./PlanDetailsCard";
import { OutOfPocket } from "./OutOfPocketCard";
import { CoPayCard } from "./CoPayCard";
import { noop } from "lodash-es";
import { TooltipMessage, TooltipTrigger } from "@coverme/elements";
import { Icon } from "@coverme/icons";

import Axios from "axios";
import { random } from "lodash";
import { Tooltip } from "../../../components/Tooltips/Tooltip";
import { saveDownloadedFile } from "../../../services/fileDownloader";

export const HealthBenefitPlanCoverage = ({ customerId, encounterId, forFacesheet = false, ...props }) => {
    const coverageJson = props.coverageJson ? JSON.parse(props.coverageJson) : null;
    const details = coverageJson.details?.length > 0 ? coverageJson.details[0] : null;

    const [selectedPlan, setSelectedPlan] = useState("Health Benefit Plan Coverage");
    const [selectedPlanObject, setSelectedPlanObject] = useState(null);
    const [isCoverageJsonDownloading, setIsCoverageJsonDownloading] = useState(false);

    useEffect(() => {
        setSelectedPlanObject(
            coverageJson?.details?.length > 0 &&
                coverageJson.details[0].plans?.length > 0 &&
                coverageJson.details[0].plans[0].benefits?.filter(x => x.name == selectedPlan)?.length > 0
                ? coverageJson.details[0].plans[0].benefits?.filter(x => x.name == selectedPlan)[0]
                : null
        );
    }, [selectedPlan]);

    function downloadCoverageJson() {
        setIsCoverageJsonDownloading(true);
        Axios.get(`/api/customer/${customerId}/encounter/${encounterId}/coverageJson`, {
            responseType: "arraybuffer",
        })
            .then(response => {
                console.log("Downloaded Coverage Json");
                setIsCoverageJsonDownloading(false);
                saveDownloadedFile(response, false, "CoverageJson_" + encounterId + random(50) + ".txt", "text/plain");
            })
            .catch(err => {
                console.log(err);
                setIsCoverageJsonDownloading(false);
                throw new Error(err);
            });
    }

    return (
        <div className={forFacesheet === true ? `facesheet_coverage_box` : ``}>
            {!forFacesheet && (
                <div className="coverage_header">
                    Coverage Results
                    {!forFacesheet && <CoverageTooltip />}
                </div>
            )}
            {details?.plans?.length > 0 && (
                <div>
                    <div className={forFacesheet === true ? `facesheet_summary_box` : `summary_box`}>
                        <div className="summaryTitle">
                            <div className="title_inside_box">Summary</div>
                            <div className={
                                            forFacesheet === true
                                                ? `download_coverage_json_btn_facesheet`
                                                : `download_coverage_json_btn`
                                        }>
                                <button
                                    type="button"
                                    className="cta cta--blue-alt cta--large "
                                    onClick={downloadCoverageJson}
                                    disabled={isCoverageJsonDownloading}
                                >
                                    <span>Coverage Details</span>
                                    <span style={{marginLeft:'13px'}}>
                                        {isCoverageJsonDownloading && <div className="simple-loader" />}
                                        {!isCoverageJsonDownloading && <Icon icon={"download"} color={"blue"} height={25} width={25} />}
                                    </span>
                                    
                                </button>
                            </div>
                        </div>
                        {details?.plans.map((person, index) => {
                            return (
                                // eslint-disable-next-line react/jsx-key
                                <div>
                                    <div className="health_benefit_plan_coverage_container">
                                        {coverageJson?.details[0]?.requestedServiceType
                                            ? coverageJson?.details[0]?.requestedServiceType[0]?.value
                                            : ""}
                                    </div>
                                    {person.status === "Active Coverage" && (
                                        <div className="active_coverage">Active Coverage</div>
                                    )}

                                    <div className="employee_only">Employee Only</div>
                                    <div className="insurance_type">Insurance Type</div>
                                    <div className="insurance_value">{person?.insuranceType}</div>
                                    <div className="plan_or_product_name">Plan/Product</div>
                                    <div className="plan_or_product_name_value">{selectedPlan}</div>
                                    {details?.plans?.length - 1 !== index && (
                                        <div>
                                            <hr className="separator" />
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                    <div
                        className={
                            forFacesheet === true
                                ? `facesheet_service_type_combo_box_width`
                                : `service_type_combo_box_width`
                        }
                    >
                        <SimpleSingleSelect
                            id="benefits"
                            options={details.plans[0]?.benefits?.map(x => {
                                return x.name;
                            })}
                            setFieldTouched={noop}
                            name={"benefits"}
                            setFieldValue={(e, v) => {
                                setSelectedPlan(v);
                            }}
                            value={selectedPlan}
                        />
                    </div>
                    <div
                        className={
                            forFacesheet === true ? `facesheet_contact_information_box` : `contact_information_box`
                        }
                    >
                        <div className="contact_information_title">Contact Information</div>
                        {details?.plans[0].contacts?.length <= 0 && (
                            <div className="primary_care_provider">
                                {details?.plans[0].contacts?.length > 0 ? details?.plans[0].contacts[0]?.category : ""}
                            </div>
                        )}
                        <div className="primary_care_provider_name">Name</div>
                        <div className="primary_care_provider_name_value">
                            {details?.plans[0].contacts?.length > 0 && details?.plans[0].contacts[0]?.name
                                ? details?.plans[0].contacts[0]?.name
                                : details?.payer?.name ?? ""}
                        </div>
                    </div>
                    {selectedPlanObject?.amounts?.deductibles && (
                        <div className={forFacesheet === true ? `facesheet_deductible_box` : `deductible_box`}>
                            <div className="out_of_pocket_title">Deductible</div>
                            {selectedPlanObject?.amounts?.deductibles?.inNetwork?.length > 0 && (
                                <PlanDetailsCard
                                    detailsObj={selectedPlanObject?.amounts?.deductibles?.inNetwork}
                                    title={"In Network"}
                                ></PlanDetailsCard>
                            )}
                            {selectedPlanObject?.amounts?.deductibles?.outOfNetwork?.length > 0 && (
                                <PlanDetailsCard
                                    detailsObj={selectedPlanObject?.amounts?.deductibles?.outOfNetwork}
                                    title={"Out Of Network"}
                                ></PlanDetailsCard>
                            )}
                            {selectedPlanObject?.amounts?.deductibles?.notApplicableNetwork?.length > 0 && (
                                <PlanDetailsCard
                                    detailsObj={selectedPlanObject?.amounts?.deductibles?.notApplicableNetwork}
                                    title={"Not Applicable Network"}
                                ></PlanDetailsCard>
                            )}
                        </div>
                    )}
                    {selectedPlanObject?.amounts?.outOfPocket && (
                        <div className={forFacesheet === true ? `facesheet_out_of_pocket_box` : `out_of_pocket_box`}>
                            <div>
                                <div className="out_of_pocket_title">Out Of Pocket</div>
                                <div>
                                    {selectedPlanObject?.amounts?.outOfPocket?.inNetwork?.length > 0 && (
                                        <OutOfPocket
                                            detailsObj={selectedPlanObject?.amounts?.outOfPocket?.inNetwork[0]}
                                            title={"In Network"}
                                        ></OutOfPocket>
                                    )}
                                    {selectedPlanObject?.amounts?.outOfPocket?.outOfNetwork?.length > 0 && (
                                        <OutOfPocket
                                            detailsObj={selectedPlanObject?.amounts?.outOfPocket?.outOfNetwork[0]}
                                            title={"Out Of Network"}
                                        ></OutOfPocket>
                                    )}
                                    {selectedPlanObject?.amounts?.outOfPocket?.notApplicableNetwork?.length > 0 && (
                                        <OutOfPocket
                                            detailsObj={
                                                selectedPlanObject?.amounts?.outOfPocket?.notApplicableNetwork[0]
                                            }
                                            title={"Not Applicable Network"}
                                        ></OutOfPocket>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                    {selectedPlanObject?.amounts?.coPayment && (
                        <div className={forFacesheet === true ? `facesheet_co_pay_box` : `co_pay_box`}>
                            <div className="co_pay_title">Co-Pay</div>
                            {selectedPlanObject?.amounts?.coPayment?.inNetwork?.length > 0 && (
                                <>
                                    <CoPayCard
                                        details={selectedPlanObject?.amounts?.coPayment?.inNetwork[0]}
                                        title={"In Network"}
                                    ></CoPayCard>
                                </>
                            )}
                            {selectedPlanObject?.amounts?.coPayment?.outOfNetwork?.length > 0 && (
                                <>
                                    <CoPayCard
                                        details={selectedPlanObject?.amounts?.coPayment?.outOfNetwork[0]}
                                        title={"Out Of Network"}
                                    ></CoPayCard>
                                </>
                            )}
                            {selectedPlanObject?.amounts?.coPayment?.notApplicableNetwork?.length > 0 && (
                                <>
                                    <CoPayCard
                                        details={selectedPlanObject?.amounts?.coPayment?.notApplicableNetwork[0]}
                                        title={"Out Of Network"}
                                    ></CoPayCard>
                                </>
                            )}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

const CoverageTooltip = () => {
    return (
        <div style={{ marginLeft: "25px" }}>
            <Tooltip>
                <TooltipTrigger>
                    <Icon icon={"tooltip"} color={"black"} height={20} width={20} />
                </TooltipTrigger>
                <TooltipMessage>
                    <p>Displays key information about a patient’s verified primary and supplemental coverage.</p>
                </TooltipMessage>
            </Tooltip>
        </div>
    );
};
